import React, { useState } from 'react';
import { captureException } from '@playbookux/playbook-web-core';
import { toast } from 'react-semantic-toasts';
import { useMutation } from '@apollo/client';
import { func, shape, string } from 'prop-types';
import { isEmpty } from 'lodash';
import {
  ElementForm, ErrorMessage, Input, MessageContainer, SaveButton,
} from '../../styles';
import { UPDATE_COMPANY_NAME } from '../../../graphql';
import { COMPANY_NAME_LENGTH, TOAST_ERROR_TIME, TOAST_SUCCESS_TIME } from './constants';
import { isNameLengthValid } from '../../utils';

const FormUpdateWorkspace = (props) => {
  const {
    onFetchCompanies = () => {},
    currentCompany = {},
    currentCompanyId = '',
  } = props;
  const [companyName, setCompanyName] = useState(currentCompany ? currentCompany.name : '');

  const [updateCompanyName, { loading }] = useMutation(UPDATE_COMPANY_NAME, {
    onCompleted: async (response) => {
      if (!isEmpty(response)) {
        toast({
          type: 'info',
          description: 'Your updates have been saved!',
          time: TOAST_SUCCESS_TIME,
        });
        await onFetchCompanies(currentCompanyId);
      }
    },
    onError: () => {
      toast({
        type: 'error',
        title: 'Error',
        description: 'Error while saving.',
        time: TOAST_ERROR_TIME,
      });
    },
  });

  const handleSaveClick = async () => {
    try {
      if (companyName?.length > 0 && companyName?.length <= COMPANY_NAME_LENGTH) {
        const response = await updateCompanyName(
          {
            variables: {
              companyId: currentCompanyId,
              attributes: {
                name: companyName,
              },
            },
          },
        );
        if (isEmpty(response?.data) && !isEmpty(response?.error)) {
          throw new Error(response?.error?.message);
        }
      }
    } catch (err) {
      captureException('UPDATE_COMPANY_NAME_ERROR', err?.message || err);
      toast({
        type: 'error',
        title: 'Error',
        description: 'Error while saving.',
        time: TOAST_ERROR_TIME,
      });
    }
  };

  return (
    <>
      <ElementForm>
        <Input
          value={companyName}
          onChange={(x, { value }) => setCompanyName(value)}
          placeholder="Enter workspace name"
          error={(companyName?.length > COMPANY_NAME_LENGTH)}
          id="company-name"
        />
        {(companyName?.length > COMPANY_NAME_LENGTH) && (
          <MessageContainer>
            <ErrorMessage>
              Must be less than 60 characters
            </ErrorMessage>
          </MessageContainer>
        )}
      </ElementForm>
      <br />
      <ElementForm>
        <SaveButton
          onClick={handleSaveClick}
          disabled={loading || isNameLengthValid(companyName, COMPANY_NAME_LENGTH)}
          loading={loading}
          id="button-update-company-name"
        >
          Save
        </SaveButton>
      </ElementForm>
    </>
  );
};

FormUpdateWorkspace.propTypes = {
  onFetchCompanies: func.isRequired,
  currentCompany: shape().isRequired,
  currentCompanyId: string.isRequired,
};

export default FormUpdateWorkspace;
